import request from '../../utils/request';

export async function getSpOpenIdRequest(params) {
  return request({
    url: 'user/getSpOpenId',
    method: 'get',
    headers: 'json',
    params,
  });
}
